import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemarksPopupComponent } from './remarks-popup.component';
import { FormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/shared/material/material.module';

@NgModule({
  declarations: [RemarksPopupComponent],
  imports: [CommonModule,FormsModule,MaterialModule],
  exports: [RemarksPopupComponent],
})
export class RemarksPopupModule {}
